export default "__VITE_ASSET__FEdnrDJx__"